import React from "react";
import { useNavigate } from "react-router-dom";
import {
  getBestMedia,
  getFullUrl,
  MEDIA_BASE_URL,
} from "../../Utils/Workout/mediaUtils";

const Workout = ({ workout, categoryName }) => {
  const navigate = useNavigate();

  if (!workout) return null;

  const bestMedia = getBestMedia(workout.media);

  const thumbnailUrl = bestMedia?.thumbnailUrl
    ? getFullUrl(bestMedia.thumbnailUrl)
    : workout?.img
      ? `${MEDIA_BASE_URL}/uploads/workout/${workout.img}`
      : null;

  const handlePlay = () => {
    navigate(`/workout/${workout._id}`);
  };

  return (
    <div className="flex-shrink-0 snap-start w-[280px] md:w-[320px]">
      <div
        className="relative rounded-3xl overflow-hidden bg-gray-200 shadow-lg border border-gray-100 cursor-pointer"
        style={{ paddingTop: "56.25%" }}
        onClick={handlePlay}
      >
        <div className="absolute inset-0">
          {thumbnailUrl ? (
            <img
              src={thumbnailUrl}
              alt={workout.title || categoryName}
              className="absolute inset-0 w-full h-full object-cover"
              onError={(e) => {
                e.target.onerror = null;
                e.target.style.display = "none";
              }}
            />
          ) : (
            <div className="absolute inset-0 bg-gradient-to-br from-gray-300 to-gray-400 flex items-center justify-center">
              <span className="text-gray-600 text-sm font-medium">
                No preview
              </span>
            </div>
          )}

          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />

          {/* Play button */}
          <div className="absolute bottom-4 left-4 z-10">
            <button
              onClick={(e) => {
                e.stopPropagation();
                handlePlay();
              }}
              className="w-12 h-12 rounded-full bg-[#c8f000] flex items-center justify-center shadow-lg hover:scale-105 active:scale-90 transition-transform"
            >
              <svg
                className="w-6 h-6 text-black ml-1"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M8 5v14l11-7z" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {workout.title && (
        <p className="mt-2 px-1 text-sm font-semibold text-gray-800 truncate">
          {workout.title}
        </p>
      )}
    </div>
  );
};

export default Workout;
